export class StoreService {

    static $inject: string[] = [
        'store',
        'jwtHelper'
    ];

    constructor(
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any
    ) {}

    getUser() {
        return this.store.get('user');
    }

    getCurrentUser() {
        const token = this.store.get('jwt');
        return token && this.jwtHelper.decodeToken(token);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/store.service.ts